import { useEffect } from "react";
import SearchBox from "src/components/core/SearchBox";
import { useAddressSearchBox, AddressSelectedData } from "src/hooks/useAddressSearchBox";
import { GeoLocation } from "src/types/common";

export const AddressSearchBox = ({
  onAddressSelected,
  onLocationChange,
  placeholder = "Address Search",
  initialValue,
}: {
  onAddressSelected: (data: AddressSelectedData) => void;
  onLocationChange: (location: GeoLocation) => void;
  placeholder?: string;
  initialValue?: string;
}) => {
  const {
    addresses,
    selectedAddress,
    searchTerm,
    setSearchTerm,
    isSearching,
    handleAddressSelected,
  } = useAddressSearchBox({
    onAddressSelected,
    onLocationChange,
  });

  // Set initial value on mount
  useEffect(() => {
    if (initialValue && !searchTerm) {
      setSearchTerm(initialValue);
    }
  }, [initialValue, searchTerm, setSearchTerm]);

  return (
    <SearchBox
      className="w-full"
      buttonClassName="w-full"
      list={addresses}
      shouldFilter={false}
      placeholder={placeholder}
      value={selectedAddress}
      onSelect={handleAddressSelected}
      inputValue={searchTerm}
      setInputValue={setSearchTerm}
      isLoading={isSearching}
    />
  );
};
